/**
 * Topology Legend (moved + adapted for DC-1648).
 *
 * Role colors via scoped CSS classes (persona-topology.css tokens); the
 * DC-1099 recommendation-badge section died with the dead `recommendations`
 * prop on the legacy GovernanceTopology.
 */

import React from 'react';

const ROLE_LEGEND: ReadonlyArray<{ role: string; className: string }> = [
  { role: 'Data Producer', className: 'role-producer' },
  { role: 'Data Enabler', className: 'role-enabler' },
  { role: 'Data Consumer', className: 'role-consumer' },
];

export const TopologyLegend: React.FC = () => (
  <div className="topology-legend">
    <h4>Legend</h4>
    <div className="legend-items">
      <div className="legend-section">
        <span className="legend-label">Primary Role:</span>
        {ROLE_LEGEND.map(({ role, className }) => (
          <div key={role} className="legend-item">
            <span className={`legend-dot ${className}`} />
            <span>{role}</span>
          </div>
        ))}
      </div>
      <div className="legend-section">
        <span className="legend-label">Indicators:</span>
        <div className="legend-item">
          <span className="legend-ring baseline" />
          <span>Baseline (Required)</span>
        </div>
        <div className="legend-item">
          <span className="legend-ring critical" />
          <span>Critical</span>
        </div>
      </div>
    </div>
  </div>
);
